// extracted by mini-css-extract-plugin
export default {"container":"home_container__BgDW7","navigation_container":"home_navigation_container__cIUPo"};